var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStraightIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 21,
    viewBox: "0 0 6 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 0.908691,
    y: 2.00391,
    width: 0.992859,
    height: 0.992981,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 1.90137,
    y: 3.00171,
    width: 0.992859,
    height: 0.992981,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 2.89453,
    y: 2.00391,
    width: 0.992859,
    height: 0.992981,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 3.88721,
    y: 3.00171,
    width: 0.992859,
    height: 0.992981,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 4.87988,
    y: 2.00391,
    width: 0.992859,
    height: 0.992981,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 0.908691,
    y: 6.00366,
    width: 0.992859,
    height: 0.992981,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 1.90137,
    y: 7.00171,
    width: 0.992859,
    height: 0.992981,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 2.89453,
    y: 6.00366,
    width: 0.992859,
    height: 0.992981,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 3.88721,
    y: 7.00171,
    width: 0.992859,
    height: 0.992981,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 4.87988,
    y: 6.00366,
    width: 0.992859,
    height: 0.992981,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 0.908691,
    y: 10.0034,
    width: 0.992859,
    height: 0.992981,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 1.90137,
    y: 11.0015,
    width: 0.992859,
    height: 0.992981,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 2.89453,
    y: 10.0034,
    width: 0.992859,
    height: 0.992981,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 3.88721,
    y: 11.0015,
    width: 0.992859,
    height: 0.992981,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 4.87988,
    y: 10.0034,
    width: 0.992859,
    height: 0.992981,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 0.908691,
    y: 14.0034,
    width: 0.992859,
    height: 0.992981,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 1.90137,
    y: 15.0015,
    width: 0.992859,
    height: 0.992981,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 2.89453,
    y: 14.0034,
    width: 0.992859,
    height: 0.992981,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 3.88721,
    y: 15.0015,
    width: 0.992859,
    height: 0.992981,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 4.87988,
    y: 14.0034,
    width: 0.992859,
    height: 0.992981,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 0.908691,
    y: 18.0034,
    width: 0.992859,
    height: 0.992981,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 1.90137,
    y: 19.0012,
    width: 0.992859,
    height: 0.992981,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 2.89453,
    y: 18.0034,
    width: 0.992859,
    height: 0.992981,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 3.88721,
    y: 19.0012,
    width: 0.992859,
    height: 0.992981,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 4.87988,
    y: 18.0034,
    width: 0.992859,
    height: 0.992981,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 0.908691,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 1.90137,
    y: 0.998047,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 2.89453,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 3.88721,
    y: 0.998047,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 4.87988,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 0.908691,
    y: 4,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 1.90137,
    y: 4.9978,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 2.89453,
    y: 4,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 3.88721,
    y: 4.9978,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 4.87988,
    y: 4,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 0.908691,
    y: 7.99976,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 1.90137,
    y: 8.9978,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 2.89453,
    y: 7.99976,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 3.88721,
    y: 8.9978,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 4.87988,
    y: 7.99976,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 0.908691,
    y: 11.9995,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 1.90137,
    y: 12.9976,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 2.89453,
    y: 11.9995,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 3.88721,
    y: 12.9976,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 4.87988,
    y: 11.9995,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 0.908691,
    y: 15.9995,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 1.90137,
    y: 16.9976,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 2.89453,
    y: 15.9995,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 3.88721,
    y: 16.9976,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 4.87988,
    y: 15.9995,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 0.908691,
    y: 19.9995,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 2.89453,
    y: 19.9995,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 4.87988,
    y: 19.9995,
    width: 0.992859,
    height: 1.00079,
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStraightIcon);
export default __webpack_public_path__ + "static/media/straightIcon.444502c3822b1f0017b95e51c9d9d848.svg";
export { ForwardRef as ReactComponent };